// File generated from our OpenAPI spec
export const ApiVersion = '2024-04-10';
